import { createContext } from 'react';

export const IcraaComplianceContext = createContext({
  isOpen: false,
  isLoading: true,
  hasComplianceError: null,
  icraaPageConfig: null,
  icraaAcceptedForApplicant: false,
  onNavLinkClick() {},
  onCancelCleanup() {},
  setIsOpen() {},
});
